export default __webpack_public_path__ + "static/imgWedding-a97650c7549f39e40a9ee76c7fbf2765.webp";